// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../config/api";
import config from "../../config/config";
import { getCurrentLoggedInSessionToken } from "../../config/userPool";

const {
  SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LISTING_ENDPOINT,
  SHUTTLE_BUS_BOOKING_SET_MAXIMUM_DETAIL_ENDPOINT,
  AUDIT_ENDPOINT,

} = config.api_endpoint;

const initialState = {
  loading: false,
  set_maximum_list: [],
  error: null,
  detail_loading: false,
  detail_data: {},
  detail_error: null,
  audit_data: [],
  audit_loading: false,
  audit_error: null,
};


export const fetchSetMaximumList = createAsyncThunk(
  "setMaximum/fetchSetMaximumList",
  async (_, { rejectWithValue }) => {
    console.log('erewreaw');
    
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LISTING_ENDPOINT}`;

      
      const results = await api.get(url, {}, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchSetMaximumDetail = createAsyncThunk(
  "setMaximum/fetchSetMaximumDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        SHUTTLE_BUS_BOOKING_SET_MAXIMUM_DETAIL_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const createAndUpdateSetMaximum = createAsyncThunk(
  "setMaximum/createAndUpdateSetMaximum",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
        const results = await api.put(
          `${SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LISTING_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const fetchSetMaximumAudit = createAsyncThunk(
  "setMaximum/fetchSetMaximumAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=booking-config&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const setMaximumSlice = createSlice({
  name: "set-maximum",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetMaximumDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchSetMaximumDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.detail_data = action.payload;
      })
      .addCase(fetchSetMaximumDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchSetMaximumAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchSetMaximumAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.audit_data = action.payload;
      })
      .addCase(fetchSetMaximumAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(fetchSetMaximumList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSetMaximumList.fulfilled, (state, action) => {
        state.loading = false;
        state.set_maximum_list = action.payload;
        console.log('afasdfasdfadsfadsfa');
        console.log(action.payload);
        
        
      })
      .addCase(fetchSetMaximumList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

const ShuttleBusSetMaximumReducer = setMaximumSlice.reducer;
export default ShuttleBusSetMaximumReducer;
